// Formats a serialized .NET TimeSpan ("[-][d.]hh:mm:ss[.fffffff]") as "hh:mm:ss".
// Days fold into the hours and fractional seconds are dropped; anything unparsable → '—'.
export function formatDuration(timeSpan: string | null | undefined): string {
  if (!timeSpan) return '—'
  const match = /^(-)?(?:(\d+)\.)?(\d{1,2}):(\d{2}):(\d{2})(?:\.\d+)?$/.exec(timeSpan)
  if (!match) return '—'
  const [, sign, days, hours, minutes, seconds] = match
  const totalHours = Number(days ?? 0) * 24 + Number(hours)
  const pad = (n: number | string) => String(n).padStart(2, '0')
  return `${sign ?? ''}${pad(totalHours)}:${minutes}:${seconds}`
}
